export enum PlatformType {
  ANDROID = 'android',
  IOS = 'ios',
  WEB = 'web'
}
